import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-709f028e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Удалить ")

import { ref, PropType } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import { removeReport } from '@/features/FRemoveReport/api/remove.api'
import { usePatientListing, useReportListing } from '@/shared/composables'
import { showErrorMessage } from '@/shared/utils'
import { ReportViewType } from '@/shared/types'


export default /*#__PURE__*/_defineComponent({
  props: {
  reportType: String as PropType<ReportViewType>,
  reportId: Number,
  patientId: String,
},
  setup(__props) {

const props = __props



const router = useRouter()

const { setUpdateReportListing } = useReportListing()
const { updatePatientListing } = usePatientListing()

const loading = ref(false)

const remove = async (): Promise<void> => {
  loading.value = true

  const [error] = await removeReport(props.reportType, props.reportId)

  if (error) {
    showErrorMessage(error)
  } else {
    ElMessage({
      message: 'Отчет удален',
      type: 'success',
    })

    setUpdateReportListing(true)
    updatePatientListing(true)

    router.push({
      name: 'PatientPage',
      params: { patientId: props.patientId },
    })
  }

  loading.value = false
}

const handleRemoveReport = (): void => {
  ElMessageBox.confirm('Подтвердите удаление отчета', 'Удаление', {
    confirmButtonText: 'Подтвердить',
    cancelButtonText: 'Отмена',
    type: 'warning',
  }).then(() => {
    remove()
  })
}

return (_ctx: any,_cache: any) => {
  const _component_icon_template = _resolveComponent("icon-template")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("button", {
    type: "button",
    class: "remove-report",
    onClick: handleRemoveReport
  }, [
    _createVNode(_component_icon_template, {
      class: "remove-report__icon",
      name: "remove",
      width: "12",
      height: "13"
    }),
    _hoisted_1
  ])), [
    [
      _directive_loading,
      loading.value,
      void 0,
      { fullscreen: true }
    ]
  ])
}
}

})